module.exports = __webpack_public_path__ + "img/nutrizon-protein-intens-79x131-2.bc49081d.png";